import { useCallback, useMemo } from 'react';

import { GapHorizontalIcon } from '@/assets/icons';
import { PropertiesLabel } from '@/modules/common/components/PropertiesLabel';
import { useReadSelectedAreas } from '@/modules/floorplanDesign/hooks';
import { areasToFlatCollection, isRackingArea } from '@/modules/floorplanDesign/helpers';
import { FddmServiceFactory } from '@/modules/canvas/services/Floorplan/FddmServiceFactory';
import { NumberInput } from '@/modules/common/components/inputs/components/NumberInput';
import { NumUtils } from '@/modules/common/utils';

export const OffsetDriving = () => {
  const selectedAreas = useReadSelectedAreas();
  const fddmSvc = useMemo(() => FddmServiceFactory.getInstance().createFddmService(), []);

  const offsetDriving = useMemo(() => {
    const areas = areasToFlatCollection(selectedAreas);
    if (areas.length !== 1) return;
    const area = areas[0];
    if (!isRackingArea(area)) return;

    return NumUtils.metersToMmRounded(area.offsetDriving);
  }, [selectedAreas]);

  const onChange = useCallback(
    (newValueMm: number) => {
      const areas = areasToFlatCollection(selectedAreas);
      if (areas.length !== 1) return;
      const area = areas[0];
      if (!isRackingArea(area)) return;

      if (Number.isNaN(newValueMm)) {
        return;
      }
      const newValue = NumUtils.mmToMeters(newValueMm);
      fddmSvc.setPreference('rackingArea.offsetDriving', newValue);
      fddmSvc.updateArea({
        ...area,
        offsetDriving: newValue,
      });
    },
    [fddmSvc, selectedAreas],
  );

  if (offsetDriving === undefined) return null;

  return (
    <PropertiesLabel i18nkey='interface:properties.area.offset_driving'>
      <NumberInput
        value={offsetDriving}
        unit='mm'
        prefix={<GapHorizontalIcon />}
        sx={{ width: '100%' }}
        onChange={onChange}
        minValue={0}
      />
    </PropertiesLabel>
  );
};
